import * as React from 'react';
import {IconButton, VerticalIconButton} from '../../../../../components/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons';
import cx from 'classnames';
type FormBlockProps = {
  title: React.ReactNode;
  children?: React.ReactNode;
  formType: string;
  onAddItem: () => void;
  disabled?: boolean;
  showBigAddButton?: boolean;
  testId?: string;
};

export function FormBlock({
  title,
  children,
  formType,
  onAddItem,
  disabled = false,
  showBigAddButton = false,
  testId = 'form-block',
}: FormBlockProps) {
  return (
    <div
      className={'rounded-[3px] border border-[#d4d9dc] flex flex-col'}
      data-testid={testId}
    >
      <h5
        className={
          'p-[10px] bg-[#eff0f0] font-medium mb-0 flex items-center justify-between'
        }
      >
        {title}
        {!showBigAddButton && (
          <IconButton
            onClick={onAddItem}
            disabled={disabled}
            data-test-id={'add-btn'}
          >
            <FontAwesomeIcon icon={faPlusCircle} className={'text-xl'} />
            新增{formType}
          </IconButton>
        )}
      </h5>
      <div
        className={cx(
          'flex flex-col items-center grow',
          'pb-[50px] min-h-0 h-0 overflow-y-auto',
          {
            'justify-start': children,
            'justify-center': children === undefined,
          },
        )}
      >
        {children}
        {showBigAddButton && (
          <div>
            <VerticalIconButton
              onClick={onAddItem}
              disabled={disabled}
              data-test-id={'add-btn'}
            >
              <FontAwesomeIcon
                icon={faPlusCircle}
                className={'text-[40px] mb-2'}
              />
              新增{formType}
            </VerticalIconButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default FormBlock;
